import React, { useState,useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/authService';
import { loadBootstrap, unloadBootstrap } from "../../utils/loadBootstrap";

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login({ username, password });
      navigate('/admin/dashboard');
    } catch (err) {
      setError('Invalid username or password');
    }
  };

    useEffect(() => {
    loadBootstrap();
    return () => unloadBootstrap();
  }, []);
  return (
  
<>
  <div className="login-wrapper d-flex align-items-center justify-content-center min-vh-100">
    <div className="login-card p-5 shadow-lg">
      <h3 className="text-center mb-4 fw-bold text-light">🚀BSCPCR Login Portal</h3>

      {error && (
        <div className="alert alert-danger text-center py-2" role="alert">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-floating mb-3">
          <input
            id="username"
            type="text"
            className="form-control bg-transparent text-light border-light neon-input"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <label htmlFor="username" className="text-light">Username</label>
        </div>

        <div className="form-floating mb-4">
          <input
            id="password"
            type="password"
            className="form-control bg-transparent text-light border-light neon-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <label htmlFor="password" className="text-light">Password</label>
        </div>

        <button
          type="submit"
          className="btn btn-light w-100 py-2 fw-semibold rounded-3 shadow-sm"
        >
          Login
        </button>
      </form>

      <p className="text-center text-light mt-3 small">
        © {new Date().getFullYear()} Admin Panel. All rights reserved.
      </p>
    </div>
  </div>

  <style>{`
    /* Animated Gradient Background */
    .login-wrapper {
      background: linear-gradient(-45deg, #4e73df, #1cc88a, #36b9cc, #f6c23e);
      background-size: 400% 400%;
      animation: gradientMove 15s ease infinite;
    }

    @keyframes gradientMove {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }

    /* Glassmorphism Card */
    .login-card {
      max-width: 400px;
      width: 100%;
      border-radius: 1rem;
      background: rgba(255, 255, 255, 0.08);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.15);
      animation: fadeIn 0.6s ease-in-out;
    }

    /* Neon Glow Effect on Focus */
    .neon-input:focus {
      outline: none;
      border-color: #00ffea;
      box-shadow: 0 0 10px #00ffea, 0 0 20px #00ffea, 0 0 30px #00ffea;
      transition: all 0.3s ease-in-out;
    }

    /* Floating Input Fields */
    .form-control:focus {
      background-color: transparent;
    }

    /* Fade In Animation */
    @keyframes fadeIn {
      from { opacity: 0; transform: translateY(-15px); }
      to { opacity: 1; transform: translateY(0); }
    }
  `}</style>
</>

    
  );
};

export default AdminLogin;
